/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { Box, Button, Select } from "@chakra-ui/react";
import { Tooltip } from "@mui/material";
import InputField from "components/fields/InputField";
import MerchantListModal from "../../shared/MerchantListModal";
import SubaccountListModal from "../../shared/SubaccountListModal";

const InputStyle =
  "daterange-picker font-medium text-navy-700 h-10 mt-2 w-full items-center shadow-sm rounded-md border bg-white/0 p-3 text-sm outline-none shadow-sm border-gray-300 dark:!border-white/10 dark:text-white";

const dateRangePropsConfigs = {
  dateNavBtnProps: {
    variant: "outline",
  },
  dayOfMonthBtnProps: {
    defaultBtnProps: {
      borderColor: "rgb(233 236 239 / 1)",
      borderRadius: "2px",
      _hover: {
        background: "gray",
        color: "white",
      },
    },
    isInRangeBtnProps: {
      background: "gray",
      color: "white",
    },
    selectedBtnProps: {
      background: "black",
      color: "white",
    },
    todayBtnProps: {
      // color: "#422afb", // Background color for today's date
      // fontWeight: "bold",
    },
  },
  inputProps: {
    // minWidth: "230px",
    className: InputStyle,
  },
  popoverCompProps: {
    popoverContentProps: {
      backgroundColor: "white",
      borderRadius: "8px",
      boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.1)",
    },
  },
  calendarPanelProps: {
    wrapperProps: {
      borderColor: "#81E6D9",
    },
    contentProps: {
      borderWidth: 0,
    },
    headerProps: {
      padding: "5px",
    },
    dividerProps: {
      display: "none",
    },
  },
  weekdayLabelProps: {
    fontWeight: "bold",
    fontSize: 16,
    color: "rgb(26 36 74)",
  },
  dateHeadingProps: {
    fontWeight: "bold",
    fontSize: 16,
    color: "rgb(26 36 74)",
  },
};

const WhitelistAddressSearch: React.FC<{
  showFilters: boolean;
  userRole: any;
  isFilterLoading: boolean;
  filters: any;
  setFilters: any;
  handleSearchSubmit: () => void;
  handleSearchClear: () => void;
  assetList: any;
}> = ({
  showFilters,
  userRole,
  isFilterLoading,
  filters,
  setFilters,
  handleSearchSubmit,
  handleSearchClear,
  assetList,
}) => {
    // Modal states for merchant and subaccount selection
    const [isMerchantModalOpen, setIsMerchantModalOpen] = useState<boolean>(false);
    const [isSubaccountModalOpen, setIsSubaccountModalOpen] = useState<boolean>(false);
    const [selectedMerchant, setSelectedMerchant] = useState<any>(null);
    const [selectedSubaccount, setSelectedSubaccount] = useState<any>(null);

    const handleInputChange = async (event: any) => {
      const { id, value } = event.target;
      setFilters({ ...filters, [id]: value });
    };

    // Handler for merchant selection from modal
    const handleMerchantSelect = (merchantData: any) => {
      setSelectedMerchant(merchantData);
      setSelectedSubaccount(null);
      localStorage.setItem("merchantIdToFilterWhitelistAddress", merchantData.id);
      localStorage.setItem("subaccountIdToFilterWhitelistAddress", "");
      setFilters({ ...filters, subaccount_id: "" });
    };

    // Clear merchant selection
    const handleClearMerchant = () => {
      setSelectedMerchant(null);
      setSelectedSubaccount(null);
      localStorage.setItem("merchantIdToFilterWhitelistAddress", "");
      localStorage.setItem("subaccountIdToFilterWhitelistAddress", "");
      setFilters({ ...filters, subaccount_id: "" });
    };

    // Handler for subaccount selection from modal
    const handleSubaccountSelect = (subaccountData: any) => {
      setSelectedSubaccount(subaccountData);
      localStorage.setItem("subaccountIdToFilterWhitelistAddress", subaccountData.id);
      setFilters({ ...filters, subaccount_id: subaccountData.id });
    };

    // Clear subaccount selection
    const handleClearSubaccount = () => {
      setSelectedSubaccount(null);
      localStorage.setItem("subaccountIdToFilterWhitelistAddress", "");
      setFilters({ ...filters, subaccount_id: "" });
    };

    const handleClear = () => {
      setSelectedMerchant(null);
      setSelectedSubaccount(null);
      localStorage.setItem("merchantIdToFilterWhitelistAddress", "");
      localStorage.setItem("subaccountIdToFilterWhitelistAddress", "");
      handleSearchClear();
    };
    if (!showFilters) return null;
    return (
      <Box className="mb-4 mt-2 rounded-lg bg-white p-6 shadow-lg ring-1 ring-gray-100">
        {userRole === "superadmin" ? (
          <>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-5">
              <div className="tracking-tight text-gray-900">
                <label className="mb-1 block text-sm font-medium text-gray-800 dark:text-white">
                  Merchant
                </label>
                <Tooltip
                  title={selectedMerchant ? selectedMerchant.name : "All"}
                  arrow
                  placement="top"
                >
                  <div
                    onClick={() => !isFilterLoading && setIsMerchantModalOpen(true)}
                    className={`relative flex w-full items-center rounded-md pl-4 pr-8 text-sm ${
                      isFilterLoading
                        ? "cursor-not-allowed bg-disabledBg font-medium text-gray-700 py-[11px]"
                        : "cursor-pointer border border-gray-300 bg-white font-medium text-navy-700 shadow-sm hover:bg-gray-50 py-2.5"
                    }`}
                  >
                    <span className="truncate">
                      {selectedMerchant ? selectedMerchant.name : "All"}
                    </span>
                    {selectedMerchant && !isFilterLoading && (
                      <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); handleClearMerchant(); }}
                        className="absolute right-2 top-1/2 -translate-y-1/2 text-lg font-medium text-gray-400 hover:text-gray-600"
                      >
                        &times;
                      </button>
                    )}
                  </div>
                </Tooltip>
              </div>

              <div className="tracking-tight text-gray-900">
                <label className="mb-1 block text-sm font-medium text-gray-800 dark:text-white">
                  Subaccount
                </label>
                <Tooltip
                  title={selectedSubaccount ? selectedSubaccount.suba_name : "All"}
                  arrow
                  placement="top"
                >
                  <div
                    onClick={() => !isFilterLoading && selectedMerchant && setIsSubaccountModalOpen(true)}
                    className={`relative flex w-full items-center rounded-md pl-4 pr-8 text-sm ${
                      isFilterLoading || !selectedMerchant
                        ? "cursor-not-allowed bg-disabledBg font-medium text-gray-700 py-[11px]"
                        : "cursor-pointer border border-gray-300 bg-white font-medium text-navy-700 shadow-sm hover:bg-gray-50 py-2.5"
                    }`}
                  >
                    <span className="truncate">
                      {selectedSubaccount ? selectedSubaccount.suba_name : "All"}
                    </span>
                    {selectedSubaccount && !isFilterLoading && (
                      <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); handleClearSubaccount(); }}
                        className="absolute right-2 top-1/2 -translate-y-1/2 text-lg font-medium text-gray-400 hover:text-gray-600"
                      >
                        &times;
                      </button>
                    )}
                  </div>
                </Tooltip>
              </div>

              <div className="tracking-tight text-gray-900">
                <label className="mb-1 block text-sm font-medium text-gray-800 dark:text-white">
                  Nickname
                </label>
                <div className="search-picker-custom">
                  <InputField
                    disabled={isFilterLoading}
                    variant="auth"
                    extra="shadow-sm rounded-md"
                    label=""
                    placeholder="Enter nickname"
                    id="nickname"
                    type="text"
                    autoComplete="off"
                    value={filters.nickname}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="tracking-tight text-gray-900">
                <label className="mb-1 block text-sm font-medium text-gray-800 dark:text-white">
                  Address
                </label>
                <div className="search-picker-custom">
                  <InputField
                    disabled={isFilterLoading}
                    variant="auth"
                    extra="shadow-sm rounded-md"
                    label=""
                    placeholder="Enter address"
                    id="address"
                    type="text"
                    autoComplete="off"
                    value={filters.address}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="tracking-tight text-gray-900">
                <label className="mb-1 block text-sm font-medium text-gray-800 dark:text-white">
                  Status
                </label>
                <Select
                  isDisabled={isFilterLoading}
                  id="status"
                  value={filters.status}
                  onChange={handleInputChange}
                  className="custom-select relative h-10 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-sm font-bold text-navy-700 shadow-sm focus:outline-none"
                >
                  <option value="">All</option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                  <option value="pending">Pending</option>
                  <option value="rejected">Rejected</option>
                </Select>
              </div>

              <div className="tracking-tight text-gray-900">
                <label className="mb-1 block text-sm font-medium text-gray-800 dark:text-white">
                  Asset
                </label>
                <Select
                  isDisabled={isFilterLoading}
                  id="asset"
                  value={filters.asset}
                  onChange={handleInputChange}
                  className="custom-select relative h-10 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-sm font-bold text-navy-700 shadow-sm focus:outline-none"
                >
                  <option value="">{assetList ? "All" : "Retrieving..."}</option>
                  {assetList &&
                    assetList.filter((item: any) => item.crypto).length > 0 && (
                      <select>
                        {assetList
                          .filter((item: any) => item.crypto)
                          .map((asset: any) => (
                            <option key={asset.name} value={asset.name}>
                              {asset.name}
                            </option>
                          ))}
                      </select>
                    )}
                </Select>
              </div>

              <div className="tracking-tight text-gray-900">
                <label className="mb-1 block text-sm font-medium text-gray-800 dark:text-white">
                  Network
                </label>
                <Select
                  isDisabled={isFilterLoading}
                  id="network"
                  value={filters.network}
                  onChange={handleInputChange}
                  className="custom-select relative h-10 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-sm font-bold text-navy-700 shadow-sm focus:outline-none"
                >
                  <option value="">All</option>
                  <option value="ethereum">Ethereum</option>
                  <option value="bitcoin">Bitcoin</option>
                  <option value="polygon">Polygon</option>
                  <option value="bsc">BSC</option>
                  <option value="arbitrum">Arbitrum</option>
                  <option value="optimism">Optimism</option>
                  <option value="avalanche">Avalanche</option>
                </Select>
              </div>

              <div className="flex items-end justify-end gap-2 md:col-span-3">
                <Button
                  isDisabled={isFilterLoading}
                  onClick={handleClear}
                  className="px-4 py-2.5 text-sm font-medium text-gray-600 hover:text-gray-700"
                >
                  Clear
                </Button>
                <Button
                  isDisabled={isFilterLoading}
                  onClick={handleSearchSubmit}
                  className="btn-primary relative overflow-hidden rounded-md px-6 py-2.5 text-sm font-medium text-white shadow-md transition-colors duration-300 hover:bg-primary-500 active:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
                >
                  <span className="relative z-10 tracking-tight">
                    Search Whitelist Addresses
                  </span>
                  <span className="absolute inset-0 z-0 scale-0 rounded-md bg-white/20 opacity-0 transition-all duration-500 group-hover:scale-150 group-hover:opacity-100" />
                </Button>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-5">
              <div className="tracking-tight text-gray-900">
                <label className="mb-1 block text-sm font-medium text-gray-800 dark:text-white">
                  Nickname
                </label>
                <div className="search-picker-custom">
                  <InputField
                    disabled={isFilterLoading}
                    variant="auth"
                    extra="shadow-sm rounded-md"
                    label=""
                    placeholder="Enter nickname"
                    id="nickname"
                    type="text"
                    autoComplete="off"
                    value={filters.nickname}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="tracking-tight text-gray-900">
                <label className="mb-1 block text-sm font-medium text-gray-800 dark:text-white">
                  Address
                </label>
                <div className="search-picker-custom">
                  <InputField
                    disabled={isFilterLoading}
                    variant="auth"
                    extra="shadow-sm rounded-md"
                    label=""
                    placeholder="Enter address"
                    id="address"
                    type="text"
                    autoComplete="off"
                    value={filters.address}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="tracking-tight text-gray-900">
                <label className="mb-1 block text-sm font-medium text-gray-800 dark:text-white">
                  Status
                </label>
                <Select
                  isDisabled={isFilterLoading}
                  id="status"
                  value={filters.status}
                  onChange={handleInputChange}
                  className="custom-select relative h-10 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-sm font-bold text-navy-700 shadow-sm focus:outline-none"
                >
                  <option value="">All</option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                  <option value="pending">Pending</option>
                  <option value="rejected">Rejected</option>
                </Select>
              </div>

              <div className="tracking-tight text-gray-900">
                <label className="mb-1 block text-sm font-medium text-gray-800 dark:text-white">
                  Asset
                </label>
                <Select
                  isDisabled={isFilterLoading}
                  id="asset"
                  value={filters.asset}
                  onChange={handleInputChange}
                  className="custom-select relative h-10 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-sm font-bold text-navy-700 shadow-sm focus:outline-none"
                >
                  <option value="">{assetList ? "All" : "Retrieving..."}</option>
                  {assetList &&
                    assetList
                      .filter((item: any) => item.crypto)
                      .map((asset: any) => (
                        <option key={asset.name} value={asset.name}>
                          {asset.name}
                        </option>
                      ))}
                </Select>
              </div>

              <div className="tracking-tight text-gray-900">
                <label className="mb-1 block text-sm font-medium text-gray-800 dark:text-white">
                  Network
                </label>
                <Select
                  isDisabled={isFilterLoading}
                  id="network"
                  value={filters.network}
                  onChange={handleInputChange}
                  className="custom-select relative h-10 w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-sm font-bold text-navy-700 shadow-sm focus:outline-none"
                >
                  <option value="">All</option>
                  <option value="ethereum">Ethereum</option>
                  <option value="bitcoin">Bitcoin</option>
                  <option value="polygon">Polygon</option>
                  <option value="bsc">BSC</option>
                  <option value="arbitrum">Arbitrum</option>
                  <option value="optimism">Optimism</option>
                  <option value="avalanche">Avalanche</option>
                </Select>
              </div>
            </div>

            <div className="flex items-center justify-end gap-2 pt-4">
              <Button
                isDisabled={isFilterLoading}
                onClick={handleClear}
                className="px-4 py-2.5 text-sm font-medium text-gray-600 hover:text-gray-700"
              >
                Clear
              </Button>

              <Button
                isDisabled={isFilterLoading}
                onClick={handleSearchSubmit}
                className="btn-primary rounded-md px-5 py-2.5 text-sm font-medium transition-all duration-200"
              >
                <span className="relative z-10 tracking-tight">
                  Search Whitelist Addresses
                </span>
                <span className="absolute inset-0 z-0 scale-0 rounded-md bg-white/20 opacity-0 transition-all duration-500 group-hover:scale-150 group-hover:opacity-100" />
              </Button>
            </div>
          </>
        )}

        {/* Merchant Selection Modal */}
        {isMerchantModalOpen && (
          <MerchantListModal
            isOpen={isMerchantModalOpen}
            onClose={() => setIsMerchantModalOpen(false)}
            onSelect={handleMerchantSelect}
          />
        )}

        {/* Subaccount Selection Modal */}
        {isSubaccountModalOpen && selectedMerchant && (
          <SubaccountListModal
            isOpen={isSubaccountModalOpen}
            onClose={() => setIsSubaccountModalOpen(false)}
            onSelect={handleSubaccountSelect}
            merchantId={selectedMerchant.id}
          />
        )}
      </Box>
    );
  };

export default WhitelistAddressSearch;
